export default __webpack_public_path__ + "static/media/ennovate_7.2e82d52c.jpg";